import type {IIdSelection} from '@netx/core-next/types';
import type {CustomVirtualizedSelection} from '../types';

export const parseCustomVirtualizedSelectionToRowSelection = <
	I extends boolean = true,
>(
	rowSelection: CustomVirtualizedSelection,
	asIntegerIds: I = true as I,
): IIdSelection<I extends true ? number : string> => {
	const {includeIds, excludeIds, ...rest} = rowSelection;
	return {
		...rest,
		includeIds: includeIds.map((id) =>
			asIntegerIds ? parseInt(id, 10) : id,
		) as (I extends true ? number : string)[],
		excludeIds: excludeIds.map((id) =>
			asIntegerIds ? parseInt(id, 10) : id,
		) as (I extends true ? number : string)[],
	};
};
